<template>
	<div class="page">
		<div class="page-inner centered-content">
			<button class="cta fill text" @click="spotifyLogin(() => { getAuthCode(); })">CONNECT WITH SPOTIFY</button>
			<table style="width:90%">
				<tr>
					<td>Spotify Auth Code</td>
					<td>
						<div style="width:50vw; overflow:hidden">{{authCode}}</div>
					</td>
				</tr>
				<tr>
					<td>
						<button @click="getTopArtists()">Get top artists</button>
					</td>
					<td>{{topArtists}}</td>
				</tr>
				<tr>
					<td>
						<button @click="getTopGenres()">Get top genres</button>
					</td>
					<td>{{topGenres}}</td>
				</tr>
				<tr>
					<td>
						<button @click="getAudioFeatures()">Get average audio features of top tracks</button>
					</td>
					<td>{{audioFeatures}}</td>
				</tr>
				<tr>
					<td>
						<button @click="getCuratedPlaylist()">Get curated playlist</button>
					</td>
					<td>{{curatedPlaylist}}</td>
				</tr>
				<tr>
					<td>
						<button @click="getArtistGeneratedTracklist()">Get artist-generated tracklist</button>
					</td>
					<td>{{artistGeneratedTracklist}}</td>
				</tr>
				<tr>
					<td>
						<button @click="getRecommendedTracklist()">Get recommended tracklist</button>
					</td>
					<td>{{recommendedTracklist}}</td>
				</tr>
				<tr>
					<td>
						<button @click="createPlaylist()">Create a playlist</button>
					</td>
					<td>{{createPlaylistOutcome}}</td>
				</tr>
			</table>
		</div>
	</div>
</template>

<script>
import SpotifyLogin from '../mixins/SpotifyLogin.js';
export default {
	components: {},
	props: {},
	mixins: [SpotifyLogin],
	data() {
		return {
			authCode: null,
			topArtists: null,
			topGenres: null,
			audioFeatures: null,
			curatedPlaylist: null,
			artistGeneratedTracklist: null,
			recommendedTracklist: null,
			createPlaylistOutcome: null
		};
	},
	created() {
		this.getAuthCode();
	},
	methods: {
		getAuthCode() {
			this.authCode = localStorage.getItem('spotifyAuthCode');
		},
		getTopArtists() {
			let app = this;
			axios
				.get('/spotify/artists/top')
				.then(function(res) {
					console.log(res);
					let artistNames = [];
					for (let artist of res.data.artists) artistNames.push(artist.name);
					app.topArtists = artistNames.join(', ');
				})
				.catch(function(res) {
					console.error(res);
					app.topArtists = 'ERROR';
				});
		},
		getTopGenres() {
			let app = this;
			axios
				.get('/spotify/genres/top')
				.then(function(res) {
					console.log(res);
					let genreNames = [];
					for (let genre of res.data.genres) genreNames.push(genre);
					app.topGenres = genreNames.join(', ');
				})
				.catch(function(res) {
					console.error(res);
					app.topGenres = 'ERROR';
				});
		},
		getAudioFeatures() {
			let app = this;
			axios
				.get('/spotify/audio-features/top')
				.then(function(res) {
					console.log(res);
					app.audioFeatures = res.data.audio_features;
				})
				.catch(function(res) {
					console.error(res);
					app.audioFeatures = 'ERROR';
				});
		},
		getCuratedPlaylist() {
			let app = this;
			axios
				.get('/spotify/playlist/25tdOaBOnEiqmWUnQ8sR7F')
				.then(function(res) {
					console.log(res);
					let trackNames = [];
					for (let item of res.data) trackNames.push(item.track.name);
					app.curatedPlaylist = trackNames.join(', ');
				})
				.catch(function(res) {
					console.error(res);
					app.curatedPlaylist = 'ERROR';
				});
		},
		getArtistGeneratedTracklist() {
			let app = this;
			axios
				.post('/spotify/tracklist/generate', {
					artist_ids: ['4Z8W4fKeB5YxbusRsdQVPb']
				})
				.then(function(res) {
					console.log(res);
					let trackNames = [];
					for (let track of res.data.tracks) trackNames.push(track.name);
					app.artistGeneratedTracklist = trackNames.join(', ');
				})
				.catch(function(res) {
					console.error(res);
					app.artistGeneratedTracklist = 'ERROR';
				});
		},
		getRecommendedTracklist() {
			let app = this;
			axios
				.get('/spotify/tracklist/recommended')
				.then(function(res) {
					console.log(res);
					let trackNames = [];
					for (let track of res.data.tracks) trackNames.push(track.name);
					app.recommendedTracklist = trackNames.join(', ');
				})
				.catch(function(res) {
					console.error(res);
					app.recommendedTracklist = 'ERROR';
				});
		},
		createPlaylist() {
			let app = this;
			axios
				.post('/spotify/playlist/create', {
					playlist_name: 'A test playlist',
					track_ids: ['3SVAN3BRByDmHOhKyIDxfC']
				})
				.then(function(res) {
					console.log(res);
					app.createPlaylistOutcome = 'SUCCESS';
				})
				.catch(function(res) {
					console.error(res);
					app.createPlaylistOutcome = 'ERROR';
				});
		}
	}
};
</script>

<style scoped>
table button {
	text-decoration: underline;
}

.swiper-slide {
	width: auto;
}
.slide-item {
	width: 300px;
	height: 300px;
	background: aqua;
	border-radius: 50%;
}

.page-inner {
	pointer-events: none;
}
.page-inner > * {
	pointer-events: auto;
}
</style>
